export const INTERCOM_ID = 'mqrkre0d';
export const POUCHERS_APP_URL = 'https://app.pouchers.io'
export const POUCHERS_WEBSITE_URL = 'https://pouchers.io'
// export const POUCHERS_LOGO_URL = "https://poucher-upload.s3.amazonaws.com/logo.png"
export const POUCHERS_LOGO_URL = "https://blog.pouchers.io/wp-content/uploads/2024/01/Screenshot-2024-01-22-at-18.17.06.png"
export const POUCHERS_VERCEL_APP_URL = 'https://poucher-frontend.vercel.app'